export const PROJECT_NAME = "Pushi";
export const PROJECT_VERSION = "v4.7.1";
export const CURRENT_YEAR = new Date().getFullYear();

export const SUPPORT_EMAIL = "DFVolkhin@sberbank.ru";

export const COMPANY_NAME = "ООО «СБЕР ЛИГАЛ»";
export const PROJECT_AUTHOR = "RND engineer Вольхин Д.Ф.";

export const ORG_GITHUB_URL = "https://github.com";
export const ORG_VK_URL = "https://vk.com";

export const STORE_VK_URL = "https://vk.com";
export const STORE_TELEGRAM_URL = "https://t.me";
